import React from "react";
import cn from "classnames";

import "./Button.scss";

export const Button = ({
  text,
  isDisabled = false,
  isLoading = false,
  variant,
  size,
  className = "",
  roundness = "half",
  children,
  ...restProps
}) => {
  const classNames = cn(
    "btn",
    variant && `btn_variant-${variant}`,
    size && `btn_size-${size}`,
    roundness && `radius_${roundness}`,
    {
      btn_disabled: isDisabled,
    },
    className
  );

  return (
    <button
      className={classNames}
      disabled={isDisabled || isLoading}
      {...restProps}
    >
      {text}
      {children}

      {isLoading && <span className="btn-spinner"></span>}
    </button>
  );
};
